<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container-xl">
                    <section class="section-hotels-edit-rooms">
                        <div class="hotels-wrap">
                          <HotelsSideMenu />
                            <div class="lds-ring" v-if="!isLoad">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div class="hotels-content" v-if="isLoad">
                                <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                                <div>
                                    <form class="safety-measurements">
                                        <div>
                                            <h2>Safety Measurements</h2>
                                          <hr />
                                        </div>
                                      <div class="row">
                                        <div class="label">Emergency Rescue Plan:</div>
                                        <div class="radio">
                                          <div class="form-control-group form-control-group--radio">
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.emergencyResquePlanAvailable = true">
                                              <input
                                                type="radio"
                                                name="emergencyResquePlanAvailable"
                                                :checked="measurements.emergencyResquePlanAvailable === true"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">Yes</span>
                                            </label>
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.emergencyResquePlanAvailable = false">
                                              <input
                                                type="radio"
                                                name="emergencyResquePlanAvailable"
                                                :checked="measurements.emergencyResquePlanAvailable === false"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">No</span>
                                            </label>
                                          </div>
                                          <div class="upload-file_container">
                                            <label class="custom-file-upload">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M15.8265 8.09459L9.55766 14.3626C8.466 15.4541 7.03154 15.9999 5.59763 16C4.16332 16.0001 2.72956 15.4543 1.63765 14.3626C-0.545882 12.1793 -0.545882 8.6269 1.63765 6.44361L6.9326 1.14934C8.46531 -0.383114 10.9592 -0.383114 12.4919 1.14934C13.2318 1.88909 13.6392 2.8761 13.6392 3.92863C13.6392 4.98115 13.2318 5.96817 12.4919 6.70796L7.31104 11.8881C6.87015 12.3289 6.29081 12.5493 5.71173 12.5494C5.1325 12.5495 4.55341 12.329 4.11247 11.8881C3.23064 11.0064 3.23064 9.57166 4.11247 8.68994L9.26612 3.53691C9.49753 3.30558 9.87261 3.30558 10.104 3.53691C10.3354 3.76829 10.3354 4.14332 10.104 4.37469L4.95036 9.52767C4.53055 9.94748 4.53055 10.6305 4.95036 11.0503C5.37022 11.4701 6.05333 11.4701 6.47319 11.0503L11.6541 5.87013C12.1701 5.35411 12.4543 4.66462 12.4543 3.92858C12.4543 3.19258 12.1701 2.50305 11.6541 1.98708C10.5833 0.916534 8.84118 0.916534 7.77049 1.98708L2.47554 7.28139C0.753985 9.00272 0.753985 11.8035 2.47554 13.5249C4.19704 15.246 6.99822 15.2461 8.71982 13.5249L14.9886 7.25686C15.22 7.02553 15.5951 7.02553 15.8265 7.25686C16.0578 7.48818 16.0578 7.86326 15.8265 8.09459Z" fill="white"/>
                                              </svg>
                                              Attach File
                                              <input type="file" @change="onFileChange" class="hidden-file-input" />
                                            </label>
                                            <div class="custom-file-name" v-if="measurements.emergencyResquePlanFile">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M15.8265 8.09459L9.55766 14.3626C8.466 15.4541 7.03154 15.9999 5.59763 16C4.16332 16.0001 2.72956 15.4543 1.63765 14.3626C-0.545882 12.1793 -0.545882 8.6269 1.63765 6.44361L6.9326 1.14934C8.46531 -0.383114 10.9592 -0.383114 12.4919 1.14934C13.2318 1.88909 13.6392 2.8761 13.6392 3.92863C13.6392 4.98115 13.2318 5.96817 12.4919 6.70796L7.31104 11.8881C6.87015 12.3289 6.29081 12.5493 5.71173 12.5494C5.1325 12.5495 4.55341 12.329 4.11247 11.8881C3.23064 11.0064 3.23064 9.57166 4.11247 8.68994L9.26612 3.53691C9.49753 3.30558 9.87261 3.30558 10.104 3.53691C10.3354 3.76829 10.3354 4.14332 10.104 4.37469L4.95036 9.52767C4.53055 9.94748 4.53055 10.6305 4.95036 11.0503C5.37022 11.4701 6.05333 11.4701 6.47319 11.0503L11.6541 5.87013C12.1701 5.35411 12.4543 4.66462 12.4543 3.92858C12.4543 3.19258 12.1701 2.50305 11.6541 1.98708C10.5833 0.916534 8.84118 0.916534 7.77049 1.98708L2.47554 7.28139C0.753985 9.00272 0.753985 11.8035 2.47554 13.5249C4.19704 15.246 6.99822 15.2461 8.71982 13.5249L14.9886 7.25686C15.22 7.02553 15.5951 7.02553 15.8265 7.25686C16.0578 7.48818 16.0578 7.86326 15.8265 8.09459Z" fill="#8A8A8A"/>
                                              </svg>
                                              <a class="custom-file-name_link" target="_blank" :href="measurements.emergencyResquePlanFile.fileUrl">{{measurements.emergencyResquePlanFile.fileName}}</a>
                                              <div class="upload-file_times" @click="measurements.emergencyResquePlanFile = null">&times;</div>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                      <div class="row">
                                        <div class="label">Fire Extinguishers:</div>
                                        <div class="radio">
                                          <div class="form-control-group form-control-group--radio">
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.fireExtinguishersAvailable = true">
                                              <input
                                                type="radio"
                                                name="fireExtinguishersAvailable"
                                                :checked="measurements.fireExtinguishersAvailable === true"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">Yes</span>
                                            </label>
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.fireExtinguishersAvailable = false">
                                              <input
                                                type="radio"
                                                name="fireExtinguishersAvailable"
                                                :checked="measurements.fireExtinguishersAvailable === false"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">No</span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="label">Fire Hose:</div>
                                        <div class="radio">
                                          <div class="form-control-group form-control-group--radio">
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.fireHoseAvailable = true">
                                              <input
                                                type="radio"
                                                name="fireHoseAvailable"
                                                :checked="measurements.fireHoseAvailable === true"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">Yes</span>
                                            </label>
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.fireHoseAvailable = false">
                                              <input
                                                type="radio"
                                                name="fireHoseAvailable"
                                                :checked="measurements.fireHoseAvailable === false"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">No</span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="label">Assembly point:</div>
                                        <div class="radio">
                                          <div class="form-control-group form-control-group--radio">
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.assemblyPointAvailable = true">
                                              <input
                                                type="radio"
                                                name="assemblyPointAvailable"
                                                :checked="measurements.assemblyPointAvailable === true"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">Yes</span>
                                            </label>
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.assemblyPointAvailable = false">
                                              <input
                                                type="radio"
                                                name="assemblyPointAvailable"
                                                :checked="measurements.assemblyPointAvailable === false"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">No</span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="label">Smoke Detectors</div>
                                        <div class="measurements-switch measurements-switch__spaced">
                                          <span class="measurements-switch_label">Public area:</span>
                                          <div style="margin-right: 10px">
                                            <ClassicSwitch v-model="measurements.smokeDetectorsPublicAreaAvailable"/>
                                          </div>
                                        </div>
                                        <div class="measurements-switch measurements-switch__spaced">
                                          <span class="measurements-switch_label">Rooms:</span>
                                          <div style="margin-right: 10px">
                                            <ClassicSwitch v-model="measurements.smokeDetectorsRoomsAvailable"/>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="label">Doctor or Nurse on site:</div>
                                        <div class="radio">
                                          <div class="form-control-group form-control-group--radio">
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.doctorOnSiteAvailable = true">
                                              <input
                                                type="radio"
                                                name="doctorOnSiteAvailable"
                                                :checked="measurements.doctorOnSiteAvailable === true"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">Yes</span>
                                            </label>
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.doctorOnSiteAvailable = false">
                                              <input
                                                type="radio"
                                                name="doctorOnSiteAvailable"
                                                :checked="measurements.doctorOnSiteAvailable === false"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">No</span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="label">Medical Kits for the guests:</div>
                                        <ClassicSelect :selected-item="measurementsMedicalKitsSelectItem" :items="measurementsMedicalKitsSelectData" custom-width="20rem" @select-item="(v) => measurements.guestMedicalKitType = v.id"/>
                                      </div>
                                      <div class="row">
                                        <div class="label">What is inside?</div>
                                        <MultiTagInput
                                          :value="measurements.guestMedicalKitContent"
                                          @update="measurements.guestMedicalKitContent = $event"
                                        />
                                      </div>
                                      <div class="row">
                                        <div class="label">AED Machine:</div>
                                        <div class="radio">
                                          <div class="form-control-group form-control-group--radio">
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.aedMachineAvailable = true">
                                              <input
                                                type="radio"
                                                name="aedMachineAvailable"
                                                :checked="measurements.aedMachineAvailable === true"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">Yes</span>
                                            </label>
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.aedMachineAvailable = false">
                                              <input
                                                type="radio"
                                                name="aedMachineAvailable"
                                                :checked="measurements.aedMachineAvailable === false"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">No</span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="label">AED EpiPen:</div>
                                        <div class="radio">
                                          <div class="form-control-group form-control-group--radio">
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.epiPenAvailable = true">
                                              <input
                                                type="radio"
                                                name="epiPenAvailable"
                                                :checked="measurements.epiPenAvailable === true"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">Yes</span>
                                            </label>
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.epiPenAvailable = false">
                                              <input
                                                type="radio"
                                                name="epiPenAvailable"
                                                :checked="measurements.epiPenAvailable === false"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">No</span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="label">Staff First Aid Certification</div>
                                        <div
                                          v-for="(item, index) in measurements.staffFirstAidCertifications"
                                          :key="index"
                                          class="aid-certification_container"
                                        >
                                          <div class="aid-certification">
                                            <div class="aid-certification_input-group">
                                              <label>Name:</label>
                                              <BasicInput type="text" v-model="item.staffName" />
                                            </div>

                                            <div class="aid-certification_input-group">
                                              <label>Course:</label>
                                              <BasicInput type="text" v-model="item.course" />
                                            </div>
                                            <div class="form-control-group form-control-group-vaild">
                                              <span class="form-control-label" style="margin-bottom: 6px;">Valid up to:</span>
                                                <div class="form-control-wrap">
                                                  <input
                                                    type="text"
                                                    placeholder="Date"
                                                    v-model="item.validUntil"
                                                    @blur="item.validUntil = $event.target.value"
                                                    class="form-control js-datepicker-single"/>
                                                  <div class="form-control-icon">
                                                    <svg
                                                      width="1em"
                                                      height="1em"
                                                      class="icon icon-calendar">
                                                      <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                    </svg>
                                                  </div>
                                                </div>
                                            </div>
                                              <button class="aid-certification_remove" @click="removeCertification(index)">&times;</button>
                                            </div>

                                            <div class="upload-file_container">
                                            <label class="custom-file-upload">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M15.8265 8.09459L9.55766 14.3626C8.466 15.4541 7.03154 15.9999 5.59763 16C4.16332 16.0001 2.72956 15.4543 1.63765 14.3626C-0.545882 12.1793 -0.545882 8.6269 1.63765 6.44361L6.9326 1.14934C8.46531 -0.383114 10.9592 -0.383114 12.4919 1.14934C13.2318 1.88909 13.6392 2.8761 13.6392 3.92863C13.6392 4.98115 13.2318 5.96817 12.4919 6.70796L7.31104 11.8881C6.87015 12.3289 6.29081 12.5493 5.71173 12.5494C5.1325 12.5495 4.55341 12.329 4.11247 11.8881C3.23064 11.0064 3.23064 9.57166 4.11247 8.68994L9.26612 3.53691C9.49753 3.30558 9.87261 3.30558 10.104 3.53691C10.3354 3.76829 10.3354 4.14332 10.104 4.37469L4.95036 9.52767C4.53055 9.94748 4.53055 10.6305 4.95036 11.0503C5.37022 11.4701 6.05333 11.4701 6.47319 11.0503L11.6541 5.87013C12.1701 5.35411 12.4543 4.66462 12.4543 3.92858C12.4543 3.19258 12.1701 2.50305 11.6541 1.98708C10.5833 0.916534 8.84118 0.916534 7.77049 1.98708L2.47554 7.28139C0.753985 9.00272 0.753985 11.8035 2.47554 13.5249C4.19704 15.246 6.99822 15.2461 8.71982 13.5249L14.9886 7.25686C15.22 7.02553 15.5951 7.02553 15.8265 7.25686C16.0578 7.48818 16.0578 7.86326 15.8265 8.09459Z" fill="white"/>
                                              </svg>
                                              Attach File
                                              <input type="file" @change="onFileInArrayChange($event, index)" class="hidden-file-input" />
                                            </label>
                                            <div class="custom-file-name" v-if="item.certificationFile">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M15.8265 8.09459L9.55766 14.3626C8.466 15.4541 7.03154 15.9999 5.59763 16C4.16332 16.0001 2.72956 15.4543 1.63765 14.3626C-0.545882 12.1793 -0.545882 8.6269 1.63765 6.44361L6.9326 1.14934C8.46531 -0.383114 10.9592 -0.383114 12.4919 1.14934C13.2318 1.88909 13.6392 2.8761 13.6392 3.92863C13.6392 4.98115 13.2318 5.96817 12.4919 6.70796L7.31104 11.8881C6.87015 12.3289 6.29081 12.5493 5.71173 12.5494C5.1325 12.5495 4.55341 12.329 4.11247 11.8881C3.23064 11.0064 3.23064 9.57166 4.11247 8.68994L9.26612 3.53691C9.49753 3.30558 9.87261 3.30558 10.104 3.53691C10.3354 3.76829 10.3354 4.14332 10.104 4.37469L4.95036 9.52767C4.53055 9.94748 4.53055 10.6305 4.95036 11.0503C5.37022 11.4701 6.05333 11.4701 6.47319 11.0503L11.6541 5.87013C12.1701 5.35411 12.4543 4.66462 12.4543 3.92858C12.4543 3.19258 12.1701 2.50305 11.6541 1.98708C10.5833 0.916534 8.84118 0.916534 7.77049 1.98708L2.47554 7.28139C0.753985 9.00272 0.753985 11.8035 2.47554 13.5249C4.19704 15.246 6.99822 15.2461 8.71982 13.5249L14.9886 7.25686C15.22 7.02553 15.5951 7.02553 15.8265 7.25686C16.0578 7.48818 16.0578 7.86326 15.8265 8.09459Z" fill="#8A8A8A"/>
                                              </svg>
                                              <a class="custom-file-name_link" :href="item.certificationFile.fileUrl" target="_blank">{{item.certificationFile.fileName}}</a>
                                              <div class="upload-file_times" @click="removeFile(index)">&times;</div>
                                            </div>
                                          </div>
                                        </div>

                                        <button class="aid-certification_add" type="button" @click="addCertification">
                                          <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                              <path d="M8.25 0C6.61831 0 5.02326 0.483854 3.66655 1.39038C2.30984 2.2969 1.25242 3.58537 0.627998 5.09286C0.00357462 6.60035 -0.159803 8.25915 0.158525 9.8595C0.476853 11.4598 1.26259 12.9298 2.41637 14.0836C3.57016 15.2374 5.04017 16.0232 6.64051 16.3415C8.24085 16.6598 9.89965 16.4964 11.4071 15.872C12.9146 15.2476 14.2031 14.1902 15.1096 12.8335C16.0162 11.4768 16.5 9.8817 16.5 8.25C16.4974 6.06276 15.6274 3.96584 14.0808 2.41922C12.5342 0.872603 10.4372 0.00258035 8.25 0ZM12 9H9V12C9 12.1989 8.92099 12.3897 8.78033 12.5303C8.63968 12.671 8.44892 12.75 8.25 12.75C8.05109 12.75 7.86033 12.671 7.71967 12.5303C7.57902 12.3897 7.5 12.1989 7.5 12V9H4.5C4.30109 9 4.11033 8.92098 3.96967 8.78033C3.82902 8.63968 3.75 8.44891 3.75 8.25C3.75 8.05109 3.82902 7.86032 3.96967 7.71967C4.11033 7.57902 4.30109 7.5 4.5 7.5H7.5V4.5C7.5 4.30109 7.57902 4.11032 7.71967 3.96967C7.86033 3.82902 8.05109 3.75 8.25 3.75C8.44892 3.75 8.63968 3.82902 8.78033 3.96967C8.92099 4.11032 9 4.30109 9 4.5V7.5H12C12.1989 7.5 12.3897 7.57902 12.5303 7.71967C12.671 7.86032 12.75 8.05109 12.75 8.25C12.75 8.44891 12.671 8.63968 12.5303 8.78033C12.3897 8.92098 12.1989 9 12 9Z" fill="white"/>
                                            </svg>
                                          </span>
                                          <span>Add</span>
                                        </button>
                                      </div>
                                      <div class="row">
                                        <div class="label">Guest may store medicine in a fridge (ex. insulin)?</div>
                                        <div class="radio">
                                          <div class="form-control-group form-control-group--radio">
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.guestCanStoreMedicationInFridge = true">
                                              <input
                                                type="radio"
                                                name="guestCanStoreMedicationInFridge"
                                                :checked="measurements.guestCanStoreMedicationInFridge ===true"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">Yes</span>
                                            </label>
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.guestCanStoreMedicationInFridge = false">
                                              <input
                                                type="radio"
                                                name="guestCanStoreMedicationInFridge"
                                                :checked="measurements.guestCanStoreMedicationInFridge === false"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">No</span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="label">Satellite phone (for emergency)?</div>
                                        <div class="radio">
                                          <div class="form-control-group form-control-group--radio">
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.satellitePhoneAvailable = true">
                                              <input
                                                type="radio"
                                                name="satellitePhoneAvailable"
                                                :checked="measurements.satellitePhoneAvailable === true"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">Yes</span>
                                            </label>
                                            <label
                                              class="form-control-radio"
                                              @click="measurements.satellitePhoneAvailable = false">
                                              <input
                                                type="radio"
                                                name="satellitePhoneAvailable"
                                                :checked="measurements.satellitePhoneAvailable === false"/>
                                              <span class="form-control-radio__box"></span>
                                              <span class="form-control-radio__name">No</span>
                                            </label>
                                          </div>
                                        </div>
                                        <ClassicSelect :selected-item="measurementsSatellitePhoneTypeSelectItem" :items="measurementsSatellitePhoneTypeSelectData" custom-width="20rem" @select-item="(v) => measurements.satellitePhoneType = v.id"/>
                                      </div>

                                      <hr />
                                        <div class="edit-rooms__btn-edit edit-rooms__btn-edit_prices">
                                            <button @click="updatePopup = true" type="button" class="btn btn--green">
                                                <span>Update</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="modal-wrapper" v-if="updatePopup">
                                <div class="modal-backdrop"></div>
                                <div class="modal-inner">
                                    <div class="edit-popup edit-popup--history">
                                        <div class="edit-popup__header">
                                            <div class="edit-popup__title">
                                                Update History
                                            </div>
                                            <div class="edit-popup__close" @click="updatePopup = false">
                                                <svg width="1em" height="1em" class="icon icon-close ">
                                                    <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                </svg>
                                            </div>
                                        </div>
                                        <form action="javascript:void(0)" class="edit-popup__inner">
                                            <div class="form-control-group"><span
                                                class="form-control-label">Hi {{
                                                    user ? user.data.firstName : ''
                                                }}, <span> what have you updated?</span> </span>
                                                <div class="form-control-wrap">
                                                    <textarea class="form-control" v-model="descriptionUpdate">Rates, Hotel Description</textarea>
                                                </div>
                                              <div class="edit-popup__error-text">
                                                <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                                              </div>
                                            </div>
                                            <div class="options-additional__btns">
                                                <button type="button" class="btn btn--silver"
                                                        @click="updatePopup = false">
                                                    <span>Cancel</span>
                                                </button>
                                                <button type="submit" class="btn btn--green edit-popup__submit"
                                                        :disabled="descriptionUpdate.length < 6"
                                                        @click="fetchSafetyMeasurements">
                                                    <span>Update</span>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import Lightpick from 'lightpick'
import { getHotelAdvanced, getHotelsSafetyMeasurements, putSafetyMeasurements, uploadFile } from '@/utilites/api'
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'
import ClassicSwitch from '@/components/UI/Switch/ClassicSwitch.vue'
import ClassicSelect from '@/components/UI/ClassicSelect/ClassicSelect.vue'
import Input from '@/components/UI/Inputs/BasicInput.vue'
import BasicInput from '@/components/UI/Inputs/BasicInput.vue'
import Checkbox from '@/components/UI/Checkbox/Checkbox.vue'
import MultiTagInput from '@/components/UI/MultiTagInput/MultiTagInput.vue'
import { date } from '@/utilites/functions'

export default {
  components: {Checkbox, BasicInput, Input, ClassicSelect, ClassicSwitch, HotelsSideMenu, MultiTagInput},
    data() {
        return {
            copyPopup: false,
            updatePopup: false,
            copyPopupFrom: '',
            copyPopupOpen: false,
            descriptionUpdate: '',
            year: new Date().getFullYear(),
            isEdit: false,
            hotelName: '',
            hotelChainId: null,
            isLoad: false,
            description: '',
            data: {years: []},
            measurements: {
              emergencyResquePlanAvailable: false,
              emergencyResquePlanFile: null,
              fireExtinguishersAvailable: false,
              fireHoseAvailable: false,
              assemblyPointAvailable: false,
              smokeDetectorsPublicAreaAvailable: false,
              smokeDetectorsRoomsAvailable: false,
              doctorOnSiteAvailable: false,
              guestMedicalKitType: "NONE",
              guestMedicalKitContent: [],
              aedMachineAvailable: false,
              epiPenAvailable: false,
              guestCanStoreMedicationInFridge: false,
              satellitePhoneAvailable: false,
              satellitePhoneType: null,
              staffFirstAidCertifications: []
            },
          measurementsMedicalKitsSelectData: [
            {id: 'NONE', name: 'None'},
            {id: 'BASIC', name: 'Basic'},
            {id: 'MEDIUM', name: 'Medium'},
            {id: 'ADVANCED', name: 'Advanced'},
          ],
          measurementsSatellitePhoneTypeSelectData: [
            {id: 'IRIDIUM', name: 'Iridium'},
            {id: 'INMARSAT', name: 'Inmarsat'},
            {id: 'THURAYA', name: 'Thuraya'},
          ],
        }
    },
    props: ['user'],
    beforeRouteLeave(to, from, next) {
        if (this.isEdit) {
            this.$emit('notLeaveHandler')
        }
        next()
    },
    created() {
        getHotelAdvanced(this.$route.params.id).then(res => {
            this.hotelName = res.names.EN
            this.hotelChainId = res.chainId
        })
    },
    mounted() {
        this.updateData()
    },
  computed: {
    measurementsMedicalKitsSelectItem() {
      return this.measurementsMedicalKitsSelectData.find(i => i.id === this.measurements.guestMedicalKitType);
    },
    measurementsSatellitePhoneTypeSelectItem() {
      return this.measurementsSatellitePhoneTypeSelectData.find(i => i.id === this.measurements.satellitePhoneType);
    }
  },
    methods: {
      async onFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        try {
          this.measurements.emergencyResquePlanFile = await uploadFile(formData);
        } catch (error) {
          console.error("Upload error:", error);
        }
      },
      addCertification() {
        this.measurements.staffFirstAidCertifications.push({
          id: null,
          staffName: "",
          course: "",
          validUntil: "",
          certificationFile: null,
        });
        this.updateDatePickers()
      },
      async onFileInArrayChange(event, index) {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        try {
          this.measurements.staffFirstAidCertifications[index].certificationFile = await uploadFile(formData);
        } catch (e) {
          console.error("Upload error:", e);
        }
      },
      removeCertification(index) {
        this.measurements.staffFirstAidCertifications.splice(index, 1);
      },
      removeFile(index) {
        this.measurements.staffFirstAidCertifications[index].certificationFile = null;
      },
        fetchSafetyMeasurements() {
          putSafetyMeasurements(this.normalizeDataSafetyMeasurements(), this.$route.params.id)
                    .then(() => {
                        this.updateData()
                        this.$emit('confirmed')
                        this.updatePopup = false
                        this.descriptionUpdate = ''
                        this.isEdit = false
                    })
        },
      normalizeDataSafetyMeasurements() {
        return {
          measurements: {
            emergencyResquePlanAvailable: this.measurements.emergencyResquePlanAvailable,
            emergencyResquePlanFileId: this.measurements.emergencyResquePlanFile ? this.measurements.emergencyResquePlanFile.id : null,
            fireExtinguishersAvailable: this.measurements.fireExtinguishersAvailable,
            fireHoseAvailable: this.measurements.fireHoseAvailable,
            assemblyPointAvailable: this.measurements.assemblyPointAvailable,
            smokeDetectorsPublicAreaAvailable: this.measurements.smokeDetectorsPublicAreaAvailable,
            smokeDetectorsRoomsAvailable: this.measurements.smokeDetectorsRoomsAvailable,
            doctorOnSiteAvailable: this.measurements.doctorOnSiteAvailable,
            guestMedicalKitType: this.measurements.guestMedicalKitType,
            guestMedicalKitContent: this.measurements.guestMedicalKitContent,
            aedMachineAvailable: this.measurements.aedMachineAvailable,
            epiPenAvailable: this.measurements.epiPenAvailable,
            guestCanStoreMedicationInFridge: this.measurements.guestCanStoreMedicationInFridge,
            satellitePhoneAvailable: this.measurements.satellitePhoneAvailable,
            satellitePhoneType: this.measurements.satellitePhoneType,
            staffFirstAidCertifications: this.measurements.staffFirstAidCertifications.map(item => ({
              id: item.id,
              staffName: item.staffName,
              course: item.course,
              validUntil: item.validUntil ? date(item.validUntil, 'norm') : null,
              certificationFileId: item.certificationFile ? item.certificationFile.id : null,
            })),
          },
          history: {
            hotelId: +this.$route.params.id,
            userId: this.user.data.id,
            description: this.descriptionUpdate
          }
        }
      },
        updateData() {
            Promise.all([getHotelsSafetyMeasurements(this.$route.params.id)])
                .then(res => {
                  const measurements = res[0]
                  this.measurements = {
                    emergencyResquePlanAvailable: measurements.emergencyResquePlanAvailable,
                    emergencyResquePlanFile: measurements.emergencyResquePlanFile,
                    fireExtinguishersAvailable: measurements.fireExtinguishersAvailable,
                    fireHoseAvailable: measurements.fireHoseAvailable,
                    assemblyPointAvailable: measurements.assemblyPointAvailable,
                    smokeDetectorsPublicAreaAvailable: measurements.smokeDetectorsPublicAreaAvailable,
                    smokeDetectorsRoomsAvailable: measurements.smokeDetectorsRoomsAvailable,
                    doctorOnSiteAvailable: measurements.doctorOnSiteAvailable,
                    guestMedicalKitType: measurements.guestMedicalKitType,
                    guestMedicalKitContent: measurements.guestMedicalKitContent,
                    aedMachineAvailable: measurements.aedMachineAvailable,
                    epiPenAvailable: measurements.epiPenAvailable,
                    guestCanStoreMedicationInFridge: measurements.guestCanStoreMedicationInFridge,
                    satellitePhoneAvailable: measurements.satellitePhoneAvailable,
                    satellitePhoneType: measurements.satellitePhoneType,
                    staffFirstAidCertifications: measurements.staffFirstAidCertifications,
                  }
                  this.isLoad = true
                    this.updateDatePickers()
                })
        },
        updateDatePickers() {
            document.querySelectorAll('.lightpick').forEach(elem => {
                elem.remove()
            })
            setTimeout(() => {
                document.querySelectorAll('.js-datepicker-single').forEach(item => {
                    const datePicker = new Lightpick({
                        field: item,
                        singleDate: true,
                        lang: 'en',
                        format: 'YYYY-MM-DD',
                        onClose: function () {
                            item.blur()
                        },
                        onSelect: function () {
                            item.focus()
                            item.blur()
                        }
                    });
                    item.addEventListener('blur', () => {
                        datePicker.hide()
                    })
                });
            }, 1000)
        },

        waitSaveTiming() {
            const saveFun = () => {
                this.updatePopup = true;
            }
            const waitFun = () => {
                this.waitSaveTiming();
            }
            setTimeout(() => {
                this.$emit('waitSaveHandler', [saveFun, waitFun]);
            }, 10 * 60 * 1000)
        },
    },
    watch: {
        isEdit(val) {
            if (val) this.waitSaveTiming();
        },
    }
}
</script>
<style lang="scss" scoped>
.safety-measurements {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.row {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.label {
  font-size: 12px;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #DADADA;
  margin: 16px 0;
  padding: 0;
}
.measurements-switch {
  display: flex;
  gap: 12px;
  align-items: center;
  max-width: 180px;

  &_label {
    font-size: 12px;
  }

  &__spaced {
    justify-content: space-between;
  }
}
.accommodation-select {
  &_label {
    font-size: 12px;
    margin-bottom: 6px;
  }
}

.radio {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 5px;
}

.input-group {
  display: flex;
  gap: 12px;
  align-items: center;
  font-size: 12px;
}

.peoplePerRoom {
  display: flex;
  gap: 22px;
  align-items: center;
  height: 36px;
}

.switches {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 140px;
}

.foodExtraCharge {
  display: flex;
  align-items: center;
  gap: 12px;
}

.car-icon {
  background: #2E2E2E;
  border-radius: 100%;
  width: 21px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-file {
  &_container {
    display: flex;
    align-items: center;
    gap: 18px;
  }

  &_times {
    font-size: 20px;
    cursor: pointer;
  }
}

.hidden-file-input {
  display: none;
}

.custom-file-upload {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  background: #77B017;
  color: #fff;
  border-radius: 80px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  max-width: 130px;
  height: 30px;
  gap: 8px;
}

.custom-file-name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #5F5F5F;

  &_link {
    all: unset;

    &:hover {
      border-bottom: 1px solid #b1b1b1;
      cursor: pointer;
    }
  }
}

.aid-certification {
  display: flex;
  gap: 22px;

  &_add {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    background: #77B017;
    color: #fff;
    border-radius: 80px;
    cursor: pointer;
    user-select: none;
    font-size: 14px;
    max-width: 100px;
    height: 30px;
    gap: 8px;
  }

  &_container {
    border: 1px solid #EAEAEA;
    border-radius: 10px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 22px;
    position: relative;
  }

  &_remove {
    font-size: 16px;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    height: 26px;
    width: 26px;
    border: 1px solid #EAEAEA;
    border-radius: 100%;
    color: #ADADAD;
  }

  &_input-group {
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
      font-size: 12px;
      font-weight: 500;
    }
  }
}
</style>